module.exports = __webpack_public_path__ + "static/media/aquarelle1.8b4467d2.svg";